<template>
  <div>
    <div class="page_header">
      <span class="page_title">{{ $t('commandHistory.pageTitle') }}</span>
      <el-form :inline="true" :size="size" style="flex: 1; text-align: right">
        <el-form-item :label="$t('vehicle.carNo')">
          <el-input clearable v-model="searchForm.CarNo" style="width: 160px"
            :placeholder="$t('vehicle.carNoPls')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('vehicle.DeviceNo')">
          <el-input clearable v-model="searchForm.DeviceNo" style="width: 160px"
            :placeholder="$t('vehicle.DeviceNoPls')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('commandHistory.commandType')">
          <el-select v-model="searchForm.CommandType" clearable style="width: 140px"
            :placeholder="$t('public.please_select')">
            <!-- <el-option :label="$t('public.all')" value="0"></el-option> -->
            <el-option :label="$t('commandHistory.cmdSetAreaLimit')" value="1"></el-option>
            <el-option :label="$t('commandHistory.cmdDelAreaLimit')" value="2"></el-option>
            <el-option :label="$t('commandHistory.cmdSetNightLimit')" value="3"></el-option>
            <el-option :label="$t('commandHistory.cmdDelNightLimit')" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('commandHistory.timeRange')">
          <el-date-picker v-model="searchForm.timeRange" type="daterange" :range-separator="$t('commandHistory.to')"
            :start-placeholder="$t('commandHistory.startDate')" :end-placeholder="$t('commandHistory.endDate')"
            value-format="yyyy-MM-dd" style="width: 260px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('public.query') }}</el-button>
          <el-button @click="handleReset">{{ $t('public.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="page_container">
      <el-table v-loading="loading" :size="size" :data="tableData" border style="width: 100%"
        :height="'calc(100vh - 360px)'">
        <el-table-column prop="CarNo" align="center" :label="$t('vehicle.carNo')" min-width="120">
        </el-table-column>
        <el-table-column prop="DeviceNo" align="center" :label="$t('vehicle.DeviceNo')" min-width="120">
        </el-table-column>
        <el-table-column prop="CommandType" align="center" :label="$t('commandHistory.commandType')" min-width="120">
          <template slot-scope="scope">
            <el-tag :size="size" :type="getCommandTypeTagType(scope.row.CommandType)">
              {{ getCommandTypeName(scope.row.CommandType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="SendTime" align="center" :label="$t('commandHistory.setTime')" min-width="180">
        </el-table-column>
        <el-table-column prop="RespTime" align="center" :label="$t('commandHistory.responseTime')" min-width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.RespTime">{{ scope.row.RespTime }}</span>
            <span v-else style="color: #909399;">--</span>
          </template>
        </el-table-column>
        <el-table-column prop="RespResult" align="center" :label="$t('commandHistory.responseResult')" min-width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.RespTime" :size="size" type="success">{{ $t('commandHistory.success') }}</el-tag>

            <el-tag v-else :size="size" type="info">{{ $t('commandHistory.pending') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="SendCount" align="center" :label="$t('commandHistory.sendCount')" width="100">
        </el-table-column>
        <el-table-column align="center" :label="$t('commandHistory.isCancel')" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.CancelTime" :size="size" type="warning">{{ $t('public.yes') }}</el-tag>
            <el-tag v-else :size="size" type="success">{{ $t('public.no') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CancelTime" align="center" :label="$t('commandHistory.cancelTime')" min-width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.CancelTime">{{ scope.row.CancelTime }}</span>
            <span v-else style="color: #909399;">--</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <kl-pagination :total="total" :page-size="form.PageSize" @current-change="handlePageChange"
          :current-page.sync="form.PageNo" @size-change="handleSizeChange">
        </kl-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { querySpeedLimitRecords } from '@/http/api'

export default {
  name: 'CommandSendHistory',
  computed: {
    ...mapState({
      size: state => state.app.size
    })
  },
  data() {
    const now = new Date()
    const endDate = this.formatDate(now)
    const startDate = this.formatDate(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000))
    return {
      loading: false,
      tableData: [],
      total: 0,
      form: {
        PageNo: 1,
        PageSize: 10
      },
      searchForm: {
        CarNo: '',
        DeviceNo: '',
        CommandType: '',
        timeRange: [startDate, endDate]
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        CarNo: this.searchForm.CarNo,
        DeviceNo: this.searchForm.DeviceNo,
        CommandType: this.searchForm.CommandType ? parseInt(this.searchForm.CommandType) : 0,
        PageNo: this.form.PageNo,
        PageSize: this.form.PageSize
      }
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.BeginTime = this.searchForm.timeRange[0] + ' 00:00:00'
        params.EndTime = this.searchForm.timeRange[1] + ' 23:59:59'
      }
      querySpeedLimitRecords(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data || []
          this.total = res.recordsTotal || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getCommandTypeName(type) {
      const types = {
        '1': this.$t('commandHistory.cmdSetAreaLimit'),
        '2': this.$t('commandHistory.cmdDelAreaLimit'),
        '3': this.$t('commandHistory.cmdSetNightLimit'),
        '4': this.$t('commandHistory.cmdDelNightLimit')
      }
      return types[type] || '未知'
    },
    getCommandTypeTagType(type) {
      const types = {
        '1': 'primary',
        '2': 'danger',
        '3': 'warning',
        '4': 'danger'
      }
      return types[type] || 'info'
    },
    handleSearch() {
      this.form.PageNo = 1
      this.loadData()
    },
    handleReset() {
      const now = new Date()
      const endDate = this.formatDate(now)
      const startDate = this.formatDate(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000))
      this.searchForm = {
        CarNo: '',
        DeviceNo: '',
        CommandType: '',
        timeRange: [startDate, endDate]
      }
      this.form.PageNo = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.form.PageNo = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.form.PageSize = size
      this.form.PageNo = 1
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page_container {
  margin-top: 16px;
}

.pagination-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>